import { TextField } from "@mui/material"
import {
  ButtonCancel,
  ButtonConfirm,
  Container,
  ContainerButtons,
  InfoCostumer,
  Loading,
  Modal,
  Title,
} from "./styles"
import { useState } from "react"

interface IModalEditReplenishment {
  open: boolean
  isLoading: boolean
  handleClose: () => void
  handleConfirm: (newQuantity: number) => void
  item: any
}

export const ModalEditReplenishment = ({
  handleClose,
  item,
  handleConfirm,
  open,
  isLoading,
}: IModalEditReplenishment) => {
  const [newReplenishmentQuantity, setNewReplenishmentQuantity] = useState(0)

  const onChangeInputNewQuantity = (e: any) => {
    setNewReplenishmentQuantity(e.target.value)
  }

  return (
    <>
      <Modal open={open}>
        <Container>
          <Loading loading={isLoading} />
          <Title>Editar abastecimento</Title>
          <InfoCostumer>
            <p>
              Produto: <strong>{item?.skuName}</strong>
            </p>
            <p>
              Quantidade atual: <strong>{item?.quantity}</strong>
            </p>
            <p>
              Mercado: <strong>{item?.marketNumber}</strong>
            </p>
          </InfoCostumer>
          <TextField
            label="Digite a quantidade correta"
            variant="outlined"
            style={{ width: "100%", margin: "16px 0 4px 0" }}
            type="number"
            defaultValue={item?.quantity}
            onChange={onChangeInputNewQuantity}
          />
          <ContainerButtons>
            <ButtonCancel onClick={handleClose} disabled={isLoading}>
              Cancelar
            </ButtonCancel>
            <ButtonConfirm
              onClick={() => handleConfirm(Number(newReplenishmentQuantity))}
              disabled={isLoading || !newReplenishmentQuantity}
            >
              Salvar
            </ButtonConfirm>
          </ContainerButtons>
        </Container>
      </Modal>
    </>
  )
}
